import { TextField as RaTextField, TextFieldProps as RaTextFieldProps } from 'react-admin';

export const TextField = RaTextField;

export type TextFieldProps = RaTextFieldProps;
